import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/SimpleAuthContext';

function Home() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-color)' }}>
      <div className="container-centered">
        <h1 className="text-5xl mb-4" style={{ letterSpacing: '4px' }}>DIVVY</h1>
        <p className="text-xl mb-12" style={{ letterSpacing: '2px' }}>AUTOMATED DIVIDEND DISTRIBUTION</p>
        
        <div className="mb-12">
          <p className="text-base mb-8" style={{ letterSpacing: '1px' }}>
            CRYPTOCURRENCY DIVIDEND SYSTEM FOR HANDCASH
          </p>
        </div>

        <div className="mb-12">
          <label className="block text-sm mb-6" style={{ letterSpacing: '1px' }}>FEATURES</label>
          <div className="grid grid-cols-3 gap-0 mb-8">
            <button className="tab-button">AUTOMATED</button>
            <button className="tab-button border-l-0">LOCKING</button>
            <button className="tab-button border-l-0">TRACKING</button>
          </div>
        </div>

        <div className="mb-12">
          <label className="block text-sm mb-6" style={{ letterSpacing: '1px' }}>DISTRIBUTION MODE</label>
          <div className="grid grid-cols-2 gap-0 mb-8">
            <button className="tab-button active">AUTOMATIC (RECOMMENDED)</button>
            <button className="tab-button border-l-0">MANUAL</button>
          </div>
        </div>

        {!user && (
          <Link to="/login">
            <button className="btn-minimal text-base">
              CONNECT WALLET
            </button>
          </Link>
        )}

        {user && (
          <Link to="/dashboard">
            <button className="btn-minimal text-base">
              ENTER DASHBOARD
            </button>
          </Link>
        )}

        <div className="mt-20 text-sm" style={{ letterSpacing: '1px' }}>
          <p className="mb-4">ABOUT</p>
          <p className="text-sm opacity-75 max-w-2xl mx-auto" style={{ letterSpacing: '0.5px', textTransform: 'none', lineHeight: '1.6' }}>
            Divvy is an automated dividend distribution system for HandCash tokens.
            Connect your HandCash wallet to manage and distribute dividends to token holders.
            Track distributions, implement token locking, and maintain complete transparency.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;